export enum AutomatedTransferNotificationType {
  AUTOMATED_TRANSFER_COMPLETED = 'AUTOMATED_TRANSFER_COMPLETED',
  AUTOMATED_TRANSFER_GEOFENCE_LEFT = 'AUTOMATED_TRANSFER_GEOFENCE_LEFT',
  AUTOMATED_TRANSFER_GEOFENCE_ENTERED = 'AUTOMATED_TRANSFER_GEOFENCE_ENTERED',
  AUTOMATED_TRANSFER_EQUIPMENT_BLOCKED = 'AUTOMATED_TRANSFER_EQUIPMENT_BLOCKED',
  AUTOMATED_TRANSFER_ITEM_PAUSED = 'AUTOMATED_TRANSFER_ITEM_PAUSED',
  AUTOMATED_TRANSFER_CANCELLED = 'AUTOMATED_TRANSFER_CANCELLED',
  AUTOMATED_TRANSFER_GEOFENCE_CHANGES = 'AUTOMATED_TRANSFER_GEOFENCE_CHANGES',
  AUTOMATED_TRANSFER_DELIVERY_TIME_EXCEEDED = 'AUTOMATED_TRANSFER_DELIVERY_TIME_EXCEEDED',
}
